"use client";

import { scroller } from "react-scroll";
import { useState, useEffect } from "react";
import CustomSigningOfferModal from "../../components/modal/CustomSigningOfferModal";

interface GuaranteeProps {
  setActiveTab: (tab: string) => void;
  activeTab: string;
  setActiveAccordion: (accordion: string) => void;
  block: {
    customSigningOfferForm: string;
  };
}

const GuarenteeClient = ({
  setActiveTab,
  activeTab,
  setActiveAccordion,
  block,
}: GuaranteeProps) => {
  const [scrollTarget, setScrollTarget] = useState<string | null>(null);
  const [showCustomSigningOfferModal, setShowCustomSigningOfferModal] =
    useState(false);

  useEffect(() => {
    if (scrollTarget && activeTab === "gyik") {
      scroller.scrollTo(scrollTarget, {
        smooth: false,
        offset: -100,
        isDynamic: true,
      });
      setScrollTarget(null);
    }
  }, [scrollTarget, activeTab]);

  return (
    <section className="guarantee">
      <div className="container">
        <div className="row">
          <div className="col">
            <div className="title">
              <h3 className="fade-in-left">Díjmentesen kipróbálható</h3>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-6">
            <div className="guarantee__side">
              <div className="bubble">
                <p>Microsoft Wordben írod a szerződéseket?</p>
              </div>
              <div className="download">
                <img src="/images/signowise-hu/sw-word.svg" alt="Signo Wise" />
                <ol>
                  <li>Töltsd le az ingyenes SignoWise Word plugint</li>
                  <li>Próbáld ki díjmentesen</li>
                  <li>
                    Válassz előfizetést jogilag érvényes aláírás használatához
                  </li>
                </ol>
                <a href="https://sjn3bn5pqfaxkdff.public.blob.vercel-storage.com/SignoWiseWordAddin.exe">
                  <button className="btn">
                    Letöltöm a Word plugint
                    <img
                      src="/images/signowise-hu/arrow-btn.svg"
                      alt="arrow-btn"
                    />
                  </button>
                </a>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="guarantee__side">
              <div className="bubble">
                <p>Vállalati dokumentumgeneráló rendszert használsz?</p>
              </div>
              <div className="download">
                <img src="/images/signowise-hu/sw-cloud.svg" alt="Signo Wise" />
                <ol>
                  <li>
                    Integráld legfeljebb pár órás munkával az ingyenes API-t
                  </li>
                  <li>Próbálj ki minden funkciót díjmentesen</li>
                  <li>
                    Válassz előfizetést jogilag érvényes aláírás használatához
                  </li>
                </ol>
                <button
                  className="btn"
                  onClick={() => setShowCustomSigningOfferModal(true)}
                >
                  Érdeklődöm
                  <img
                    src="/images/signowise-hu/arrow-btn.svg"
                    alt="arrow-btn"
                  />
                </button>
                <CustomSigningOfferModal
                  showModal={showCustomSigningOfferModal}
                  setShowModal={setShowCustomSigningOfferModal}
                  block={block}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="row mt-5">
          <div className="col">
            <div className="title">
              <h3 className="fade-in-left">Egyszerűen használható</h3>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col">
            <div className="easy">
              <ul>
                <li>
                  <i className="fa fa-file-text-o" aria-hidden="true"></i>
                  <h5>1. HELYEZZ EL ALÁÍRÁSMEZŐT</h5>
                  <p>Véglegesítsd az ügyféldokumentumot úgy, ahogy szoktad</p>
                  <p>Helyezd el az aláírásmezőket egy-egy kattintással</p>
                  <p>
                    Újabb kattintással indítsd az aláírást Wordből vagy Cloud
                    megoldás esetén a saját rendszeredből
                  </p>
                </li>
                <li>
                  <i className="fa fa-pencil" aria-hidden="true"></i>
                  <h5>2. ÍRJ ALÁ</h5>
                  <p>
                    Írj alá a tableted vagy a PC-d képernyőjén, vagy akár
                    egérrel
                  </p>
                </li>
                <li>
                  <i className="fa fa-cloud-download" aria-hidden="true"></i>
                  <h5>3. KÉSZEN IS VAGY</h5>
                  <p>
                    A minden fél által aláírt, a rendszerünk általunk is
                    hitelesített PDF dokumentumot elmentheted, továbbküldheted
                  </p>
                  <p>
                    Cloud megoldás esetén a mentés és az archiválás
                    automatizálható
                  </p>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-12">
            <h4>Nézd meg videón is, hogyan működik</h4>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-12">
            <div className="video">
              <iframe
                src="https://www.youtube-nocookie.com/embed/eENr2K-ujY4"
                title="YouTube video player"
                frameBorder="0"
              ></iframe>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-12">
            <div className="questions">
              <div className="questions__bottom">
                <h4>Tudástárunkban részletes útmutatókat találsz</h4>
                <div
                  className="link"
                  onClick={() => {
                    setScrollTarget("hogy-mukodik-a-signowise-word-plugin");
                    setActiveTab("gyik");
                    setActiveAccordion("hogy-mukodik-a-signowise-word-plugin");
                  }}
                >
                  SignoWise Word plugin{" "}
                  <img src="/images/signowise-hu/arrow-blue.svg" alt="Arrow" />
                </div>
                <div
                  className="link"
                  onClick={() => {
                    setScrollTarget("hogy-mukodik-a-signowise-integracio");
                    setActiveTab("gyik");
                    setActiveAccordion("hogy-mukodik-a-signowise-integracio");
                  }}
                >
                  SignoWise Cloud integrálása{" "}
                  <img src="/images/signowise-hu/arrow-blue.svg" alt="Arrow" />
                </div>
                <div
                  className="link"
                  onClick={() => {
                    setScrollTarget(
                      "melyik-a-szamomra-legpraktikusabb-felhasznalas",
                    );
                    setActiveTab("gyik");
                    setActiveAccordion(
                      "melyik-a-szamomra-legpraktikusabb-felhasznalas",
                    );
                  }}
                >
                  Melyik megoldásra van szükségem?{" "}
                  <img src="/images/signowise-hu/arrow-blue.svg" alt="Arrow" />
                </div>
                <div
                  className="link"
                  onClick={() => {
                    setScrollTarget("mik-a-leggyakrabban-hasznalt-tabletek");
                    setActiveTab("gyik");
                    setActiveAccordion("mik-a-leggyakrabban-hasznalt-tabletek");
                  }}
                >
                  Milyen aláíró eszközt használhatok?{" "}
                  <img src="/images/signowise-hu/arrow-blue.svg" alt="Arrow" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default GuarenteeClient;
